import React from 'react';

import { TextField } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './ThemedTextField.sass';

export const ThemedTextField = React.forwardRef((props, ref) => {
  const { shrink, className: propsClassName, ...rest } = props;

  const classes = classnames('themed-text-field', {
    [`${propsClassName}`]: !!propsClassName,
  });
  return (
    <TextField
      ref={ref}
      InputLabelProps={shrink ? { shrink: true } : {}}
      className={classes}
      {...rest}
    />
  );
});

ThemedTextField.displayName = 'ThemedTextField';

ThemedTextField.propTypes = {
  className: PropTypes.string,
  shrink: PropTypes.bool,
};

ThemedTextField.defaultProps = {
  className: '',
  shrink: false,
};
